module.exports = __webpack_public_path__ + "img/precios.d33b1bb1.svg";